module.exports = __webpack_public_path__ + "img/03mazda-miata-rf.860fdcc4.png";